var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vue-calc-btn",attrs:{"disabled":_vm._disabled},on:{"click":_vm.submitOption}},[_vm._v(" "+_vm._s(_vm.nextStepLabel ? _vm.nextStepLabel : "Passer à l'étape suivante")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }